// extracted by mini-css-extract-plugin
export default {"root":"ToC2T","normal":"_2Iyry","tier-link":"hrVPM","tierLink":"hrVPM"};